import { WIDGET_MOBILE_BREAKPOINT } from 'utils/constants';
import useElementBreakpoint from './useElementBreakpoint';

export function useDesktopElement() {
  return useElementBreakpoint({ min: WIDGET_MOBILE_BREAKPOINT + 1 });
}

export function useMobileElement() {
  return useElementBreakpoint({ max: WIDGET_MOBILE_BREAKPOINT });
}

export { useElementBreakpoint };
export { default as useElementBreakpoints } from './useElementBreakpoints';
